var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#C3BBB5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-286 -41) translate(286 41)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.857,
    height: 14.857,
    x: 0.571,
    y: 1.571,
    strokeWidth: 1.143,
    rx: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.143,
    d: "M5 0L5 4M13 0L13 4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2,
    d: "M0 6L17 6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6038f2fb5ed7480f57f0189914f5b743.svg";
export { ForwardRef as ReactComponent };